import React from "react";
import { Input } from "@/components/ui/input";
import { CountryField } from "@/components/CountryField";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LANGUAGES, langName } from "@/lib/constants";
import { useLang } from "@/i18n";
import EmailField from "@/components/EmailField";

export const blankGuest = { first_name: "", last_name: "", email: "", phone: "", language: "nl", country: "", license_plate: "", notes: "", rood_lintje: false };

function Field({ label, children }) {
  return (<div className="space-y-1.5"><Label className="text-xs">{label}</Label>{children}</div>);
}

export default function GuestFormFields({ form, setForm, compact = false }) {
  const { t, lang } = useLang();
  return (
    <div className="grid grid-cols-2 gap-3">
      <Field label={t("first_name")}><Input value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} data-testid="guest-first-name" /></Field>
      <Field label={t("last_name")}><Input value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} data-testid="guest-last-name" /></Field>
      <Field label={t("email")}><EmailField value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} testid="guest-email" /></Field>
      <Field label={t("phone")}><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="guest-phone" /></Field>
      <Field label={t("language")}>
        <Select value={form.language} onValueChange={(v) => setForm({ ...form, language: v })}>
          <SelectTrigger data-testid="guest-language"><SelectValue /></SelectTrigger>
          <SelectContent>{LANGUAGES.map((l) => <SelectItem key={l.code} value={l.code}>{langName(l.code, lang)}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label={t("country")}><CountryField value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} testid="guest-country" /></Field>
      <Field label={t("license_plate")}><Input value={form.license_plate} onChange={(e) => setForm({ ...form, license_plate: e.target.value })} data-testid="guest-plate" /></Field>
      <label className="col-span-2 flex items-center gap-2 rounded-md border border-border px-3 py-2 text-sm text-muted-foreground cursor-pointer hover:bg-muted" data-testid="guest-ribbon">
        <input type="checkbox" className="accent-rose-600" checked={!!form.rood_lintje} onChange={(e) => setForm({ ...form, rood_lintje: e.target.checked })} />
        <span className="h-2.5 w-2.5 rounded-full bg-rose-600" />{t("ribbon_guest")}
      </label>
      {!compact && <div className="col-span-2"><Field label={t("notes")}><Textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></Field></div>}
    </div>
  );
}
